import { NgModule } from '@angular/core';
import { NavigationComponent } from './navigation.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { IconsModule } from '../icons/icons.module';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonModule } from '../button/button/button.module';
import { MatBadgeModule } from '@angular/material/badge';
import { ZalamoDialogModule } from '../zalamo-dialog/zalamo-dialog.module';
import { SideDialogModule } from '../side-dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ZalamoTooltipModule } from '../zalamo-tooltip/zalamo-tooltip.module';
import { SmartPreviewModule } from '../smart-preview/smart-preview.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { NavigationSubMenuComponent } from './navigation-sub-menu/navigation-sub-menu.component';
import { TranslationsModule } from '../nls/translations/translations.module';
import { UploadModule } from '../../upload/upload.module';
import { CommonModule } from '@angular/common';
import { SubNavigationContainerComponent } from './sub-navigation-container/sub-navigation-container.component';
import { StoreModule } from '@ngrx/store';
import * as fromNavigationState from './navigation-state/navigation-state.reducer';
import { UnseenCommentsIconModule } from 'ZalamoLibrary/src/lib/ui/comments/unseen-comments-icon/unseen-comments-icon.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FabButtonModule } from 'ZalamoLibrary/src/lib/ui/fab-button/fab-button.module';
import { ObserversModule } from '@angular/cdk/observers';
import { ScrollbarModule } from 'ZalamoLibrary/src/lib/ui/scrollbar/scrollbar.module';
import { MatDialogModule } from '@angular/material/dialog';
import { UserModule } from 'ZalamoLibrary/src/lib/zalamo/user/user.module';

@NgModule({
  declarations: [
    NavigationComponent,
    NavigationSubMenuComponent,
    SubNavigationContainerComponent,
  ],
  imports: [
    CommonModule,
    IconsModule,
    MatListModule,
    MatIconModule,
    MatMenuModule,
    RouterModule.forChild([]),
    MatButtonModule,
    MatProgressSpinnerModule,
    ButtonModule,
    MatSlideToggleModule,
    UploadModule,
    MatBadgeModule,
    ZalamoDialogModule,
    SideDialogModule,
    DragDropModule,
    ZalamoTooltipModule,
    SmartPreviewModule,
    ProgressSpinnerModule,
    TranslationsModule.forRoot(['library']),
    StoreModule.forFeature(
      fromNavigationState.navigationStateFeatureKey,
      fromNavigationState.reducer,
    ),
    UnseenCommentsIconModule,
    MatTooltipModule,
    FabButtonModule,
    ObserversModule,
    ScrollbarModule,
    UserModule,
  ],
  exports: [
    NavigationComponent,
    NavigationSubMenuComponent,
    SubNavigationContainerComponent,
  ],
})
export class NavigationModule {}
